import React, { Component } from 'react';
import moment from 'moment';
import unescape from 'lodash/unescape';

import Icon from 'components/common/Icon';

export default class PageList extends Component {

  renderList() {
    const { pages, renderItem } = this.props;

    if (pages.length === 0) {

      return (
        <div>
          <div className="list-group">
            <div className="list-item">
              <div className="inner">
                <div className="no-events">No Pages</div>
              </div>
            </div>
          </div>
        </div>
      );
    }

    return (
      <div key="listGroup">
        <div className="list-group">
          {pages.map((page, key) => {
            if (pages.length > 1 && key + 1 < pages.length) {
              return renderItem(page, true);
            }
            return renderItem(page);
          })}
        </div>
      </div>
    );
  }

  render() {
    const { pages, isLoading } = this.props;

    if (!Array.isArray(pages) || (pages.length === 0 && isLoading)) {
      // Could display a loading spinner but parent is handling this for now
      return <span />;
    }

    return (
      <section className="full-screen-list">
        {this.renderList()}
      </section>
    );
  }
}

PageList.defaultProps = {
  isLoading: true,
};



// WEBPACK FOOTER //
// ./src/app/components/calendar/PageList.js